import http from 'utils/http';
import { getPerformanceUrl } from './apiUrls';
import { CallPerformanceResponse } from './types';

export function getPerformance(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<CallPerformanceResponse> {
  return http.get(getPerformanceUrl(workspaceId, agentId), params);
}
